import React, { Component } from "react";
import PropTypes from "prop-types";
import { Range } from "rc-slider";

import { configs, colors } from "../../configs";

import style from "./style.module.css";
import { getClosestPoint } from "../../utils";
import { SvgLoader, SvgProxy } from "../react-svgmt/index";

const sliderValueToRealRange = val => val / 10;

const Handle = (idle, themeName, arrow) => props => {
  if (props.index === 1) {
    return null;
  }
  const width = 0;
  return (
    <div
      className={`rc-slider-handle`}
      style={{
        ...props.style,
        height: "50px",
        left: `${props.offset}%`,
        width: `${width}px`,
        textAlign: "right",
        position: "relative"
      }}
    >
      {arrow && (
        <div className={style.triangles}>
          <div className={`${style.triangleUR} ${themeName}Border`} />
          <div className={`${style.triangleDR} ${themeName}Border`} />
        </div>
      )}
      <div className={style.ripple} style={{ opacity: idle ? "1" : 0 }}>
        <img src={"/icons/ripple.svg"} />
      </div>
    </div>
  );
};

const stepValue = configs.sliderMax / configs.sliderSteps;
const markPoints = new Array(Math.floor(stepValue) + 1)
  .fill(null)
  .map((_, i) => i * configs.sliderSteps);

const sliderMark = pct => {
  const tr = pct < 100 ? "130%" : "135%";
  return (
    <span
      key={pct}
      style={{
        position: "relative",
        display: "flex",
        width: "36px",
        height: "50px"
      }}
    >
      <span
        style={{
          position: "absolute",
          transform: `rotate(90deg) translate(0%, ${tr})`,
          height: "100%",
          width: "100%",
          lineHeight: "0px",
          fontSize: "13px",
          color: colors.dark[1]
        }}
      >
        {pct}%
      </span>
    </span>
  );
};

const sliderMarks = (currentValue, color) => {
  const marks = markPoints.filter(i => i >= currentValue).reduce((a, b) => {
    const pct = b / 10;
    return {
      ...a,
      [b]: {
        label: pct > 0 ? sliderMark(pct) : <span />,
        style: {
          background: pct === 100 ? "transparent" : color,
          marginLeft: `0 !important`,
          // borderRight: `3px solid ${color}`,
          width: `3px`,
          height: `${configs.sliderHeight - configs.sliderBarHeight}px`
        }
      }
    };
  }, {});
  return marks;
};

export class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      min: configs.sliderMin,
      max: configs.sliderMax,
      value: [configs.sliderMin, configs.sliderMax],
      idle: true
    };
  }

  onSliderChange = value => {
    //if it is the top bound handle to be ignored
    const minVal = value[0];
    const maxVal = value[1];

    if (maxVal < configs.sliderMax && minVal !== configs.sliderMax) {
      return;
    }

    if (minVal < this.props.minValue) {
      return;
    }

    this.setState({ idle: false });
    this.setSliderValue(minVal);
  };

  onAfterChange = value => {
    const closestPoint = getClosestPoint(
      value[0],
      configs.sliderMin,
      configs.sliderSteps
    );
    this.props.onAfterChange(sliderValueToRealRange(closestPoint));

    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.setState({ idle: true });
    }, configs.idleTime);
  };

  setSliderValue = val => {
    this.props.onChange(sliderValueToRealRange(val));
  };

  render() {
    const {
      sliderColors,
      sliderHeight,
      sliderBarHeight,
      sliderPadding
    } = configs;
    const { theme, disabled, value, themeName } = this.props;
    const gradient = `linear-gradient(to right, ${sliderColors.join(",")})`;
    return (
      <div
        className={`${style.sliderWrapper} ${disabled && style.disabled}`}
        style={{
          height: `${sliderHeight}px`
        }}
      >
        <div
          className={`condensed ${style.sliderBar}`}
          style={{
            background: gradient,
            height: `100%`
          }}
        >
          <span
            className={style.sliderValue}
            style={{ paddingLeft: `${sliderPadding}px` }}
          >
            <label>AV</label>
            <span>{~~(value / 10)}%</span>
          </span>
        </div>
        <Range
          defaultValue={[configs.sliderMin, configs.sliderMax]}
          min={configs.sliderMin}
          max={configs.sliderMax}
          value={[value, configs.sliderMax]}
          onChange={this.onSliderChange}
          onAfterChange={this.onAfterChange}
          marks={sliderMarks(this.state.value[0], theme.sliderMarksColor)}
          style={{
            paddingTop: `${sliderBarHeight}px`,
            marginLeft: "10%"
          }}
          trackStyle={[
            {
              height: sliderHeight - sliderBarHeight,
              backgroundColor: theme.sliderTrackColor
            }
          ]}
          handleStyle={[
            {
              backgroundColor: "transparent",
              height: sliderHeight - sliderBarHeight
            }
          ]}
          railStyle={{
            backgroundColor: "transparent",
            height: sliderHeight
          }}
          handle={Handle(this.state.idle, themeName, value < 1000)}
          allowCross={false}
          disabled={disabled}
        />
        {/* <SliderPctMarks pcts={[20, 40, 60, 80, 100]} color={"#404041"} />*/}
      </div>
    );
  }
}

Slider.propTypes = {
  onChange: PropTypes.func.isRequired,
  steps: PropTypes.number
};




// WEBPACK FOOTER //
// ./src/components/slider/index.js